import React from 'react'
import { Column } from 'primereact/column'
import DateBodyTemplate from './DateBodyTemplate'
import CalendarEditor from './CalendarEditor'
import DateFilterTemplate from '../Filters/DateFilterTemplate'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

const DateColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isDateFieldChanged, isFieldChangedOverride, validationErrors, template, originalData }) => {
    const filterAttributes = {
        filter,
        filterPlaceholder: `Search by  ${title}`,
        required: !!filter,
        disabled: !filter
    }
    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isDateFieldChanged || isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            dataType="date"
            body={(rowData) => (
                <span className={`${checkFieldChanged(rowData) ? 'changed-field' : ''} ${rowData.isDeleted ? 'pending-deletion' : ''}`}>
                    {template ? template(rowData) : <DateBodyTemplate rowData={rowData} field={mapsToField} />}
                </span>
            )}
            editor={editable ? (options) => <CalendarEditor key={options.rowData._editKey} options={options} validationErrors={validationErrors} /> : null}
            filterElement={(options) => <DateFilterTemplate options={options} />}
            {...filterAttributes}/>
    )
}

export default DateColumn
